module.exports = __webpack_public_path__ + "static/screens_mix-a165c2c4d14714a1c2ca8ea27ae41c90.png";